import { token } from '@/infrastructure/container';
import { type IAppBus } from './AppBus';

export interface IDomKeyboard {
  start(): void;
}

export const TOKEN_IDomKeyboard = token<IDomKeyboard>('IDomKeyboard');

export class DomKeyboard implements IDomKeyboard {
  private started = false;

  constructor(private bus: IAppBus) {}

  start(): void {
    if (this.started) return;
    this.started = true;
    document.addEventListener('keydown', this.onKeyDown);
  }

  private onKeyDown = (e: KeyboardEvent): void => {
    if (this.isFromFormControl(e.target)) return;
    this.bus.keyDown({
      key: e.key,
      ctrl: e.ctrlKey,
      meta: e.metaKey,
      shift: e.shiftKey,
      alt: e.altKey,
      preventDefault: () => e.preventDefault(),
    });
  };

  private isFromFormControl(target: EventTarget | null): boolean {
    if (!(target instanceof HTMLElement)) return false;
    const tag = target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
    if (target.isContentEditable) return true;
    return false;
  }
}
